import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-page-toolbar',
  standalone: true,
  template: `
    <div
      class="page-toolbar"
      [class.page-toolbar--wrap]="wrap"
      [class.page-toolbar--between]="justify === 'between'"
      [class.page-toolbar--start]="justify === 'start'"
      [class.page-toolbar--end]="justify === 'end'"
    >
      <ng-content />
    </div>
  `,
  styles: [`
    .page-toolbar {
      display: flex;
      align-items: center;
      gap: 12px;
      min-width: 0;
    }

    .page-toolbar--wrap {
      flex-wrap: wrap;
    }

    .page-toolbar--between {
      justify-content: space-between;
    }

    .page-toolbar--start {
      justify-content: flex-start;
    }

    .page-toolbar--end {
      justify-content: flex-end;
    }
  `],
})
export class PageToolbarComponent {
  @Input() public wrap = true;
  @Input() public justify: 'start' | 'between' | 'end' = 'start';
}
